<span [ngClass]="messageExportJob.isCalculatedTitle ? 'calculated-title' : ''" data-type="job-subject">
   {{messageExportJob.isCalculatedTitle ? 'Calculated title' : messageExportJob.messageSubject}}
</span>
